import React from 'react';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';

export class ProductShipping extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.state.open = this.props.open;
    this.toggleOpen = this.toggleOpen.bind(this);
  }
  toggleOpen() {
    this.setState({ open: !this.state.open });
  }
  render() {
    return (
      <div className='panel product-shipping-wrapper hide-when-international'>
        <button
          onClick={this.toggleOpen}
          className='panel-title product-shipping-title'
          aria-controls={`product-shipping-${this.props.contentData.productId}`}
          aria-expanded={this.state.open ? 'true' : 'false'}
        >
          Shipping and Returns{' '}
          {this.state.open ? (
            <i className='panel-icon expanded'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          ) : (
            <i className='panel-icon'>
              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48.84 48.84'>
                <title>plus</title>
                <g data-name='Layer 2'>
                  <g data-name='Layer 1'>
                    <path d='M47.84,23.41H25.47V1a1,1,0,0,0-2,0v22.4H1a1,1,0,0,0,0,2H23.45v22.4a1,1,0,1,0,2,0V25.43H47.84a1,1,0,1,0,0-2Z' />
                  </g>
                </g>
              </svg>
            </i>
          )}
        </button>
        {this.state.open ? (
          <SetInnerHTML
            className='col-sm-12 product-shipping'
            innerHTML={this.props.contentData.ES_Shipping_Returns_JSON}
            espotname='ES_Shipping_Returns_JSON'
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default ProductShipping;
